import { Pipe, PipeTransform } from '@angular/core';
import { getCurrentBaseDomain } from '../helpers/helper-functions';

@Pipe({
  name: 'fileDownloadPath',
})
export class FileDownloadPathPipe implements PipeTransform {
  baseURL = getCurrentBaseDomain();

  transform(value: string): unknown {
    return value;
  }
}
